{
 "_doc": "DEADMONTON iso world component types. One source of truth for pipeline/build_iso.py (Python), the server and the client. Cell = 0.5 m. Heights in metres. hp 0 = indestructible. Colours are hex strings: top, south face, east face (east is the lit side; the key light is from the upper right / north-east).",
 "cell_m": 0.5,
 "ground": {
  "0": {
   "key": "void",
   "c": [
    "#0f0e22"
   ]
  },
  "1": {
   "key": "asphalt",
   "c": [
    "#3f3f47",
    "#46464e",
    "#43434b"
   ]
  },
  "2": {
   "key": "line_y",
   "c": [
    "#c8a83a"
   ]
  },
  "3": {
   "key": "line_w",
   "c": [
    "#c9c9c1"
   ]
  },
  "4": {
   "key": "sidewalk",
   "c": [
    "#a29e95",
    "#ada99f",
    "#97938a"
   ],
   "joint": "#86827a"
  },
  "5": {
   "key": "pavers",
   "c": [
    "#9a4e35",
    "#8e4434",
    "#a8583c"
   ],
   "joint": "#6a3326"
  },
  "6": {
   "key": "curb",
   "c": [
    "#c6c2b8"
   ]
  },
  "7": {
   "key": "alley",
   "c": [
    "#6e6258",
    "#7a6d62",
    "#5f544b"
   ]
  },
  "8": {
   "key": "lot",
   "c": [
    "#56565e",
    "#5e5e66"
   ]
  },
  "9": {
   "key": "grass",
   "c": [
    "#5d7a3c",
    "#6a8a44",
    "#4f6a33"
   ]
  },
  "10": {
   "key": "dirt",
   "c": [
    "#7d6b55",
    "#8a775f",
    "#6c5c49"
   ]
  },
  "11": {
   "key": "planks",
   "c": [
    "#8a7a66",
    "#958570",
    "#7d6e5c"
   ],
   "joint": "#5e5244"
  },
  "12": {
   "key": "checker",
   "c": [
    "#d8d4cc",
    "#2a2a2e"
   ]
  },
  "13": {
   "key": "concrete",
   "c": [
    "#8c877d",
    "#857f75",
    "#938e84"
   ]
  },
  "14": {
   "key": "carpet",
   "c": [
    "#6a2a2a",
    "#742f2e",
    "#622626"
   ]
  },
  "15": {
   "key": "crosswalk",
   "c": [
    "#d6d6ce",
    "#3f3f47"
   ]
  },
  "16": {
   "key": "lino",
   "c": [
    "#b8b2a4",
    "#c2bcae"
   ]
  },
  "17": {
   "key": "stone",
   "c": [
    "#3a3a46",
    "#42424e",
    "#34343e"
   ],
   "joint": "#22222c"
  },
  "18": {
   "key": "earth",
   "c": [
    "#3e3428",
    "#46392c",
    "#382f24"
   ]
  },
  "19": {
   "key": "hollow",
   "c": [
    "#1d3436",
    "#22403f",
    "#183032"
   ],
   "glow": "#6e9ea6"
  },
  "20": {
   "key": "stairs",
   "c": [
    "#2a2a30",
    "#4a4a52"
   ]
  },
  "21": {
   "key": "basement",
   "c": [
    "#5e5a54",
    "#66625b",
    "#57534d"
   ]
  },
  "22": {
   "key": "tile_white",
   "c": [
    "#d6d8d4",
    "#cfd1cd"
   ],
   "joint": "#9ea09c"
  }
 },
 "struct": {
  "0": {
   "key": "none"
  },
  "1": {
   "key": "wall",
   "blocks": true,
   "hp": 600,
   "doc": "plain wall in the cell's material"
  },
  "2": {
   "key": "storefront",
   "blocks": true,
   "hp": 40,
   "base_glass": true,
   "glass_z": [
    0.45,
    2.6
   ]
  },
  "3": {
   "key": "door",
   "blocks": true,
   "hp": 160,
   "door": true,
   "door_z": 2.2
  },
  "4": {
   "key": "door_glass",
   "blocks": true,
   "hp": 60,
   "door": true,
   "door_z": 2.2,
   "base_glass": true
  },
  "5": {
   "key": "window",
   "blocks": true,
   "hp": 40,
   "glass_z": [
    0.9,
    2.2
   ]
  },
  "6": {
   "key": "partition",
   "blocks": true,
   "hp": 60,
   "glass_z": [
    0.9,
    2.5
   ]
  },
  "7": {
   "key": "rubble",
   "blocks": false,
   "hp": 0,
   "low": 0.35
  },
  "8": {
   "key": "smashed",
   "blocks": false,
   "hp": 0,
   "doc": "a broken storefront / window: frame left, you can climb through"
  },
  "9": {
   "key": "door_open",
   "blocks": false,
   "hp": 160,
   "door": true,
   "open": true
  },
  "10": {
   "key": "railing",
   "blocks": true,
   "hp": 120,
   "low": 1.0
  },
  "11": {
   "key": "fence",
   "blocks": true,
   "hp": 150,
   "low": 1.8
  },
  "12": {
   "key": "hatch_wall",
   "blocks": true,
   "hp": 0,
   "doc": "dungeon boundary, indestructible"
  }
 },
 "material": {
  "0": {
   "key": "none"
  },
  "1": {
   "key": "brick_red",
   "top": "#7a3a2c",
   "s": "#8e4434",
   "e": "#a8523e",
   "mortar": "#b0a08a",
   "pattern": "brick",
   "hp_mult": 1
  },
  "2": {
   "key": "brick_brown",
   "top": "#5e3a2a",
   "s": "#6e4430",
   "e": "#84553c",
   "mortar": "#a09080",
   "pattern": "brick",
   "hp_mult": 1
  },
  "3": {
   "key": "brick_cream",
   "top": "#b8a07a",
   "s": "#c8b08a",
   "e": "#dcc49c",
   "mortar": "#8e806a",
   "pattern": "brick",
   "hp_mult": 1
  },
  "4": {
   "key": "stucco_grey",
   "top": "#7e7a74",
   "s": "#8c8780",
   "e": "#a29d95",
   "pattern": "plain",
   "hp_mult": 0.7
  },
  "5": {
   "key": "block_grey",
   "top": "#6e675f",
   "s": "#7a7269",
   "e": "#8a8178",
   "mortar": "#5e5850",
   "pattern": "block",
   "hp_mult": 1.2
  },
  "6": {
   "key": "wood_black",
   "top": "#141414",
   "s": "#1c1c1e",
   "e": "#2a2a2c",
   "pattern": "boards",
   "band": "#e8341c",
   "hp_mult": 0.5
  },
  "7": {
   "key": "plaster",
   "top": "#d8d2c6",
   "s": "#c8c2b6",
   "e": "#e2ddd2",
   "pattern": "plain",
   "hp_mult": 0.4
  },
  "8": {
   "key": "red_wall",
   "top": "#7a2a1a",
   "s": "#9a2c1a",
   "e": "#b5321e",
   "pattern": "plain",
   "hp_mult": 1.0
  },
  "9": {
   "key": "stone_dk",
   "top": "#2e2e38",
   "s": "#3a3a46",
   "e": "#4a4a58",
   "mortar": "#22222c",
   "pattern": "block",
   "hp_mult": 0
  },
  "10": {
   "key": "hollow",
   "top": "#1a2c2e",
   "s": "#20383a",
   "e": "#2c4a4c",
   "glow": "#6e9ea6",
   "pattern": "veins",
   "hp_mult": 0
  },
  "11": {
   "key": "iron",
   "top": "#222226",
   "s": "#2a2a30",
   "e": "#3a3a42",
   "pattern": "bars",
   "hp_mult": 0.8
  },
  "12": {
   "key": "glass",
   "top": "#3a5a6a",
   "s": "#4a6e80",
   "e": "#6a90a0",
   "pattern": "plain",
   "hp_mult": 0.15
  },
  "13": {
   "key": "siding_teal",
   "top": "#2f5552",
   "s": "#3a6662",
   "e": "#4a7a76",
   "pattern": "boards",
   "hp_mult": 0.5
  },
  "14": {
   "key": "concrete",
   "top": "#8c8a86",
   "s": "#9a9894",
   "e": "#b0aeaa",
   "pattern": "block",
   "hp_mult": 0
  }
 },
 "prop": {
  "bar": {
   "m": [
    1,
    0.7
   ],
   "z": 1.1,
   "hp": 300,
   "blocks": true,
   "top": "#141414",
   "s": "#2a2420",
   "e": "#3a322c",
   "doc": "black-topped bar counter, wood-front",
   "container": "bar"
  },
  "backbar": {
   "m": [
    1,
    0.5
   ],
   "z": 2.2,
   "hp": 200,
   "blocks": true,
   "top": "#2a2018",
   "s": "#3a2c20",
   "e": "#4a3828",
   "detail": "bottles",
   "container": "backbar"
  },
  "hightable": {
   "m": [
    0.8,
    0.8
   ],
   "z": 1.05,
   "hp": 60,
   "blocks": true,
   "top": "#6b4a2e",
   "s": "#3a2a1c",
   "e": "#4a3424",
   "legs": true
  },
  "stool": {
   "m": [
    0.45,
    0.45
   ],
   "z": 0.78,
   "hp": 20,
   "blocks": false,
   "top": "#9a2a2a",
   "s": "#1c1c1c",
   "e": "#2a2a2a",
   "legs": true
  },
  "chair": {
   "m": [
    0.45,
    0.45
   ],
   "z": 0.48,
   "hp": 20,
   "blocks": false,
   "top": "#9a2a2a",
   "s": "#1c1c1c",
   "e": "#2a2a2a",
   "legs": true,
   "back": 0.95
  },
  "lowtable": {
   "m": [
    1.2,
    0.75
   ],
   "z": 0.76,
   "hp": 60,
   "blocks": true,
   "top": "#6b4a2e",
   "s": "#3a2a1c",
   "e": "#4a3424",
   "legs": true
  },
  "table2": {
   "m": [
    1.0,
    1.0
   ],
   "z": 0.76,
   "hp": 60,
   "blocks": true,
   "top": "#6b4a2e",
   "s": "#3a2a1c",
   "e": "#4a3424",
   "legs": true,
   "doc": "a small square table (1.0 x 1.0 m): the 4-top's and the short booth bay's (tools/art/kit stamps)"
  },
  "booth": {
   "m": [
    0.6,
    1.8
   ],
   "z": 0.48,
   "hp": 120,
   "blocks": true,
   "top": "#1c1a1a",
   "s": "#141212",
   "e": "#2a2626",
   "back": 1.15
  },
  "booth_corner": {
   "m": [
    1.5,
    1.5
   ],
   "z": 0.48,
   "hp": 120,
   "blocks": true,
   "top": "#1c1a1a",
   "s": "#141212",
   "e": "#2a2626",
   "doc": "an L-shaped corner booth: two 1.5 m benches meeting in a corner, backs to two walls (its table sits in the L); face = one arm's facing, the other arm faces the next way clockwise (tools/art/kit/room_layout.py seat_cells)"
  },
  "ledge": {
   "m": [
    1,
    0.4
   ],
   "z": 1.05,
   "hp": 120,
   "blocks": true,
   "top": "#2a2c30",
   "s": "#1a1a1c",
   "e": "#242428"
  },
  "tv": {
   "m": [
    0.2,
    1.1
   ],
   "z": 2.3,
   "hp": 30,
   "blocks": false,
   "wall": true,
   "z0": 1.7,
   "top": "#101014",
   "s": "#101014",
   "e": "#3a6aa0",
   "screen": "#5a9ad0"
  },
  "chalkboard": {
   "m": [
    0.1,
    1.4
   ],
   "z": 2.3,
   "hp": 30,
   "blocks": false,
   "wall": true,
   "z0": 1.2,
   "top": "#5a3a22",
   "s": "#1e2a22",
   "e": "#24322a"
  },
  "photos": {
   "m": [
    0.1,
    3.0
   ],
   "z": 2.2,
   "hp": 0,
   "blocks": false,
   "wall": true,
   "z0": 1.2,
   "top": "#141414",
   "s": "#141414",
   "e": "#c8b89a",
   "doc": "the red wall of black-framed photos"
  },
  "jersey": {
   "m": [
    0.1,
    1.2
   ],
   "z": 2.5,
   "hp": 0,
   "blocks": false,
   "wall": true,
   "z0": 1.3,
   "top": "#141414",
   "s": "#141414",
   "e": "#3a2a20",
   "doc": "a faded orange-and-blue hockey jersey in a frame, no crest, no name, no number (R11 round 8: the Oilers in the Tavern without a trademark); painted by client/src/iso_render.ts propSpec"
  },
  "shovel": {
   "m": [
    0.1,
    0.4
   ],
   "z": 2.3,
   "hp": 0,
   "blocks": false,
   "wall": true,
   "z0": 1.3,
   "top": "#d8b040",
   "s": "#b89030",
   "e": "#f0c850",
   "doc": "the gold shovel (STORY: the plant)"
  },
  "amp": {
   "m": [
    0.6,
    0.4
   ],
   "z": 0.7,
   "hp": 40,
   "blocks": true,
   "top": "#1a1a1a",
   "s": "#141414",
   "e": "#202020"
  },
  "speaker": {
   "m": [
    0.45,
    0.45
   ],
   "z": 1.9,
   "hp": 40,
   "blocks": true,
   "top": "#141414",
   "s": "#101010",
   "e": "#1a1a1a",
   "legs": true
  },
  "drums": {
   "m": [
    1.2,
    1.0
   ],
   "z": 0.8,
   "hp": 40,
   "blocks": true,
   "top": "#c8c8c0",
   "s": "#7a1e1e",
   "e": "#9a2626"
  },
  "keg": {
   "m": [
    0.45,
    0.45
   ],
   "z": 0.6,
   "hp": 80,
   "blocks": true,
   "top": "#a8a8b0",
   "s": "#7a7a84",
   "e": "#9a9aa4"
  },
  "shelf": {
   "m": [
    1,
    0.45
   ],
   "z": 2.0,
   "hp": 80,
   "blocks": true,
   "top": "#5a5248",
   "s": "#4a443c",
   "e": "#5e564c",
   "detail": "boxes",
   "container": "shelf"
  },
  "toilet": {
   "m": [
    0.45,
    0.6
   ],
   "z": 0.75,
   "hp": 30,
   "blocks": true,
   "top": "#e8e8e4",
   "s": "#c8c8c4",
   "e": "#dadad6"
  },
  "sink": {
   "m": [
    0.5,
    0.45
   ],
   "z": 0.9,
   "hp": 30,
   "blocks": true,
   "top": "#e8e8e4",
   "s": "#a8a8a4",
   "e": "#bababa"
  },
  "stall": {
   "m": [
    0.1,
    1.5
   ],
   "z": 1.9,
   "hp": 40,
   "blocks": true,
   "top": "#4a5a6a",
   "s": "#3a4a5a",
   "e": "#5a6a7a"
  },
  "hatch": {
   "m": [
    1.0,
    1.0
   ],
   "z": 0.04,
   "hp": 0,
   "blocks": false,
   "top": "#3a2a1a",
   "s": "#2a1e12",
   "e": "#2a1e12",
   "detail": "hatch",
   "doc": "the trapdoor nobody knew about"
  },
  "cooler": {
   "m": [
    1.4,
    0.7
   ],
   "z": 1.0,
   "hp": 120,
   "blocks": true,
   "top": "#a8acb0",
   "s": "#8a8e92",
   "e": "#9a9ea2",
   "container": "cooler"
  },
  "lamp": {
   "m": [
    0.3,
    0.3
   ],
   "z": 5.0,
   "hp": 200,
   "blocks": true,
   "top": "#1a1a1e",
   "s": "#26262c",
   "e": "#34343c",
   "pole": true,
   "light": "#ffd38a"
  },
  "tree": {
   "m": [
    0.5,
    0.5
   ],
   "z": 6.0,
   "hp": 0,
   "blocks": true,
   "top": "#4f6a33",
   "s": "#5a4330",
   "e": "#6a5038",
   "crown": 2.4
  },
  "bench": {
   "m": [
    1.6,
    0.5
   ],
   "z": 0.5,
   "hp": 80,
   "blocks": true,
   "top": "#6a4a2a",
   "s": "#2a2a2c",
   "e": "#38383c",
   "back": 0.9
  },
  "bin": {
   "m": [
    0.5,
    0.5
   ],
   "z": 1.0,
   "hp": 40,
   "blocks": true,
   "top": "#2a3a2a",
   "s": "#223022",
   "e": "#2e402e"
  },
  "hydrant": {
   "m": [
    0.35,
    0.35
   ],
   "z": 0.8,
   "hp": 0,
   "blocks": true,
   "top": "#d8c040",
   "s": "#b89a20",
   "e": "#e0c430"
  },
  "planter": {
   "m": [
    1.2,
    1.2
   ],
   "z": 0.6,
   "hp": 100,
   "blocks": true,
   "top": "#4f6a33",
   "s": "#6a6058",
   "e": "#7a7066"
  },
  "car": {
   "m": [
    4.4,
    1.9
   ],
   "z": 1.45,
   "hp": 400,
   "blocks": true,
   "top": "#2a2a30",
   "s": "#5a5a62",
   "e": "#7a7a84",
   "car": true
  },
  "dumpster": {
   "m": [
    1.9,
    1.1
   ],
   "z": 1.3,
   "hp": 300,
   "blocks": true,
   "top": "#2a4a2a",
   "s": "#2a3e2a",
   "e": "#365236",
   "container": "dumpster"
  },
  "bikerack": {
   "m": [
    1.0,
    0.3
   ],
   "z": 0.8,
   "hp": 0,
   "blocks": true,
   "top": "#9a9aa2",
   "s": "#7a7a84",
   "e": "#8a8a94"
  },
  "pillar": {
   "m": [
    0.5,
    0.5
   ],
   "z": 3.2,
   "hp": 0,
   "blocks": true,
   "top": "#3a3a46",
   "s": "#42424e",
   "e": "#4e4e5c"
  },
  "dais": {
   "_doc": "studio 008: Malrec's dais in the records room, a low walk-over platform (the renderer draws everyone on it over it)",
   "m": [
    7.0,
    7.0
   ],
   "z": 0.5,
   "hp": 0,
   "blocks": false,
   "top": "#2c4a4c",
   "s": "#20383a",
   "e": "#2c4a4c"
  },
  "lectern": {
   "_doc": "studio 008: the records room's three lecterns (docs/levels/ch1-records-room.md); code-drawn claim text over it",
   "m": [
    1.0,
    0.6
   ],
   "z": 1.15,
   "hp": 0,
   "blocks": true,
   "top": "#9a7448",
   "s": "#5a3a22",
   "e": "#6a4a2e"
  },
  "bones": {
   "m": [
    0.8,
    0.8
   ],
   "z": 0.15,
   "hp": 0,
   "blocks": false,
   "top": "#c8c0a8",
   "s": "#a89e86",
   "e": "#b8ae96"
  },
  "crate": {
   "m": [
    0.8,
    0.8
   ],
   "z": 0.8,
   "hp": 40,
   "blocks": true,
   "top": "#8a6a3e",
   "s": "#6a4e2c",
   "e": "#7a5a34",
   "container": "crate"
  },
  "pod": {
   "m": [
    1.0,
    1.0
   ],
   "z": 1.3,
   "hp": 90,
   "blocks": true,
   "top": "#2c5a58",
   "s": "#20403e",
   "e": "#2c5250",
   "glow": "#9cc4c6",
   "doc": "a Hollow egg-sac; breaking it can release something",
   "container": "pod"
  },
  "shrine": {
   "m": [
    1.0,
    1.0
   ],
   "z": 1.5,
   "hp": 0,
   "blocks": true,
   "top": "#c9e3e0",
   "s": "#3a5e5a",
   "e": "#4e7a74",
   "glow": "#9cc4c6",
   "doc": "a Hollow shrine (audit item 12): E to touch it; one effect, then it crumbles"
  },
  "ladder": {
   "m": [
    1.0,
    1.0
   ],
   "z": 0.04,
   "hp": 0,
   "blocks": false,
   "top": "#3a2a1a",
   "s": "#2a1e12",
   "e": "#2a1e12",
   "detail": "ladder",
   "doc": "the way back up"
  },
  "fridge": {
   "m": [
    0.8,
    0.75
   ],
   "z": 1.8,
   "hp": 150,
   "blocks": true,
   "top": "#e8e8e4",
   "s": "#c8c8c4",
   "e": "#dadad6",
   "container": "fridge"
  },
  "stove": {
   "m": [
    0.75,
    0.65
   ],
   "z": 0.9,
   "hp": 150,
   "blocks": true,
   "top": "#2a2a2e",
   "s": "#c8c8c4",
   "e": "#dadad6"
  },
  "counter": {
   "m": [
    2.0,
    0.65
   ],
   "z": 0.9,
   "hp": 150,
   "blocks": true,
   "top": "#c8b89a",
   "s": "#6a4a2e",
   "e": "#7a5a3a",
   "container": "counter"
  },
  "couch": {
   "m": [
    2.0,
    0.9
   ],
   "z": 0.85,
   "hp": 100,
   "blocks": true,
   "top": "#6a4a2e",
   "s": "#5a3a22",
   "e": "#6a4a2e"
  },
  "bed": {
   "m": [
    2.0,
    1.0
   ],
   "z": 0.6,
   "hp": 100,
   "blocks": true,
   "top": "#3a5a8a",
   "s": "#5a4030",
   "e": "#6a5040"
  },
  "desk": {
   "m": [
    1.4,
    0.7
   ],
   "z": 1.2,
   "hp": 100,
   "blocks": true,
   "top": "#6a4a2e",
   "s": "#5a3a22",
   "e": "#6a4a2e",
   "container": "cabinet"
  },
  "bookshelf": {
   "m": [
    1.0,
    0.35
   ],
   "z": 1.9,
   "hp": 100,
   "blocks": true,
   "top": "#5a3a22",
   "s": "#4a3020",
   "e": "#5a3a22",
   "container": "cabinet"
  },
  "rack": {
   "m": [
    1.4,
    0.5
   ],
   "z": 1.6,
   "hp": 60,
   "blocks": true,
   "top": "#3a3a40",
   "s": "#4a6a8a",
   "e": "#8a4a4a",
   "container": "crate"
  },
  "checkout": {
   "m": [
    1.6,
    0.7
   ],
   "z": 1.1,
   "hp": 150,
   "blocks": true,
   "top": "#c8c8c4",
   "s": "#3a3a40",
   "e": "#4a4a52",
   "container": "checkout"
  },
  "storeshelf": {
   "m": [
    2.0,
    0.6
   ],
   "z": 1.8,
   "hp": 120,
   "blocks": true,
   "top": "#c8c8c4",
   "s": "#a8a8a4",
   "e": "#bababa",
   "container": "storeshelf"
  },
  "pallet": {
   "m": [
    1.2,
    1.0
   ],
   "z": 1.0,
   "hp": 80,
   "blocks": true,
   "top": "#8a6a3e",
   "s": "#6a4e2c",
   "e": "#7a5a34",
   "container": "crate"
  },
  "cabinet": {
   "m": [
    0.5,
    0.6
   ],
   "z": 1.3,
   "hp": 100,
   "blocks": true,
   "top": "#8a8e92",
   "s": "#7a7e82",
   "e": "#8a8e92",
   "container": "cabinet"
  },
  "officechair": {
   "m": [
    0.6,
    0.6
   ],
   "z": 1.1,
   "hp": 30,
   "blocks": false,
   "top": "#1c1c1e",
   "s": "#141416",
   "e": "#1c1c1e"
  },
  "arcade": {
   "m": [
    0.7,
    0.8
   ],
   "z": 1.8,
   "hp": 80,
   "blocks": true,
   "top": "#141414",
   "s": "#1c1c1c",
   "e": "#2a2a2a"
  },
  "pooltable": {
   "m": [
    2.2,
    1.2
   ],
   "z": 0.8,
   "hp": 200,
   "blocks": true,
   "top": "#2a6a3a",
   "s": "#5a3a22",
   "e": "#6a4a2e"
  },
  "newsbox": {
   "m": [
    0.5,
    0.45
   ],
   "z": 1.1,
   "hp": 60,
   "blocks": true,
   "top": "#3a5a8a",
   "s": "#2a4a7a",
   "e": "#3a5a8a"
  },
  "mailbox": {
   "m": [
    0.5,
    0.5
   ],
   "z": 1.2,
   "hp": 0,
   "blocks": true,
   "top": "#c8302c",
   "s": "#a8282a",
   "e": "#c8302c"
  },
  "busstop": {
   "m": [
    1.2,
    0.5
   ],
   "z": 2.6,
   "hp": 0,
   "blocks": true,
   "top": "#3a3a40",
   "s": "#2a2a30",
   "e": "#3a3a40"
  },
  "cone": {
   "m": [
    0.35,
    0.35
   ],
   "z": 0.7,
   "hp": 10,
   "blocks": false,
   "top": "#ff7a1a",
   "s": "#e06a10",
   "e": "#ff7a1a"
  },
  "barrier": {
   "m": [
    2.0,
    0.6
   ],
   "z": 0.8,
   "hp": 0,
   "blocks": true,
   "top": "#b0aeaa",
   "s": "#9a9894",
   "e": "#b0aeaa"
  },
  "cart": {
   "m": [
    0.9,
    0.55
   ],
   "z": 1.0,
   "hp": 40,
   "blocks": true,
   "top": "#9a9aa2",
   "s": "#7a7a84",
   "e": "#8a8a94"
  },
  "umbrella": {
   "m": [
    0.5,
    0.5
   ],
   "z": 2.4,
   "hp": 30,
   "blocks": true,
   "top": "#2e4a34",
   "s": "#243a2a",
   "e": "#2e4a34",
   "doc": "a furled patio umbrella (review R11-003)"
  },
  "heater": {
   "m": [
    0.5,
    0.5
   ],
   "z": 2.3,
   "hp": 60,
   "blocks": true,
   "top": "#b8bcc0",
   "s": "#8a8e92",
   "e": "#a8acb0"
  },
  "sandwich": {
   "m": [
    0.6,
    0.4
   ],
   "z": 1.0,
   "hp": 20,
   "blocks": true,
   "top": "#6a4a2e",
   "s": "#1e2a22",
   "e": "#24322a",
   "doc": "an A-frame board outside a shop"
  },
  "picnic": {
   "m": [
    1.8,
    1.4
   ],
   "z": 0.8,
   "hp": 80,
   "blocks": true,
   "top": "#8a7a66",
   "s": "#6a5a48",
   "e": "#7a6a56"
  },
  "deckbench": {
   "m": [
    2.0,
    0.5
   ],
   "z": 0.5,
   "hp": 80,
   "blocks": true,
   "top": "#8a8478",
   "s": "#6a645a",
   "e": "#7a746a"
  },
  "lattice": {
   "m": [
    2.0,
    0.2
   ],
   "z": 1.8,
   "hp": 40,
   "blocks": true,
   "top": "#e8e4dc",
   "s": "#c8c4bc",
   "e": "#d8d4cc",
   "doc": "white lattice with climbing vines (the Black Dog deck)"
  },
  "basement_stair": {
   "m": [
    1.0,
    3.0
   ],
   "z": 1.0,
   "hp": 0,
   "blocks": true,
   "top": "#2a2a2e",
   "s": "#141416",
   "e": "#1c1c1e",
   "detail": "stair_down",
   "doc": "studio 009m: steps down from the sidewalk to a basement door, behind a black iron rail (NutTea under the Strathcona Hotel); w x d is the stairwell along the wall it serves (face: the wall's side); drawn by code, no lettering"
  },
  "railing": {
   "m": [
    1.5,
    0.1
   ],
   "z": 1.0,
   "hp": 60,
   "blocks": true,
   "top": "#1c1c1e",
   "s": "#141416",
   "e": "#222226",
   "doc": "black iron patio rail, about 1 m tall and 0.1 m deep, as long as its w (Whyte's patios); the cell STRUCT 'railing' is a separate thing"
  },
  "greasebin": {
   "m": [
    0.7,
    0.6
   ],
   "z": 0.9,
   "hp": 60,
   "blocks": true,
   "top": "#8a8a84",
   "s": "#6a6a64",
   "e": "#7a7a74"
  },
  "chairtip": {
   "m": [
    0.8,
    0.5
   ],
   "z": 0.5,
   "hp": 20,
   "blocks": false,
   "top": "#9a2a2a",
   "s": "#1c1c1c",
   "e": "#2a2a2a",
   "doc": "a patio chair knocked over"
  },
  "bistro": {
   "m": [
    0.6,
    0.6
   ],
   "z": 0.75,
   "hp": 40,
   "blocks": true,
   "top": "#1c1c1e",
   "s": "#141416",
   "e": "#1c1c1e",
   "legs": true
  },
  "planterbox": {
   "m": [
    1.8,
    0.5
   ],
   "z": 0.7,
   "hp": 60,
   "blocks": true,
   "top": "#6a5030",
   "s": "#5a4028",
   "e": "#6a4a2e"
  },
  "recycling": {
   "m": [
    0.7,
    0.7
   ],
   "z": 1.1,
   "hp": 40,
   "blocks": true,
   "top": "#2a5a9a",
   "s": "#1e4a82",
   "e": "#2a5a9a",
   "container": "dumpster"
  },
  "cardboard": {
   "m": [
    1.0,
    0.8
   ],
   "z": 0.3,
   "hp": 10,
   "blocks": false,
   "top": "#9a7a4e",
   "s": "#7a5e3a",
   "e": "#8a6a44"
  },
  "pole": {
   "m": [
    0.35,
    0.35
   ],
   "z": 8.0,
   "hp": 0,
   "blocks": true,
   "top": "#5a4330",
   "s": "#4a3828",
   "e": "#5a4330",
   "pole": true,
   "doc": "a wooden utility pole in the alley (review R11-008)"
  },
  "handcart": {
   "m": [
    1.6,
    0.9
   ],
   "z": 0.9,
   "hp": 60,
   "blocks": true,
   "top": "#7a5a34",
   "s": "#5a4024",
   "e": "#6a4a2c"
  },
  "supplies": {
   "m": [
    1.0,
    0.8
   ],
   "z": 0.7,
   "hp": 40,
   "blocks": true,
   "top": "#c8c8c0",
   "s": "#8a8a84",
   "e": "#a0a09a"
  }
 },
 "_hp": "A wall cell's hp = struct.hp x material.hp_mult for solid walls (concrete and dungeon stone are 0 = indestructible); glass, doors and partitions use struct.hp as is."
}
